var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShareEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19 5.25C19.9182 5.25 20.6712 5.95711 20.7442 6.85647L20.75 7V17C20.75 17.9182 20.0429 18.6712 19.1435 18.7442L19 18.75H5C4.08183 18.75 3.32881 18.0429 3.2558 17.1435L3.25 17V7C3.25 6.08183 3.95711 5.32881 4.85647 5.2558L5 5.25H19ZM19.25 7.773L12.4881 13.5694C12.2384 13.7834 11.8832 13.8072 11.6101 13.6408L11.5119 13.5694L4.75 7.774V17C4.75 17.1183 4.83223 17.2175 4.94268 17.2434L5 17.25H19C19.1183 17.25 19.2175 17.1678 19.2434 17.0573L19.25 17V7.773ZM18.138 6.75H5.861L12 12.011L18.138 6.75Z",
    fill: "#00322E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShareEmail);
export default __webpack_public_path__ + "static/media/share-email.3bc0c289f8325e1879e980bd5eff6c4f.svg";
export { ForwardRef as ReactComponent };